var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAvatarExample(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 42,
    viewBox: "0 0 40 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_993_3125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 41.218C31.0155 41.218 40 32.1341 40 20.9965C40 9.85859 31.0157 0.774658 20 0.774658C8.9843 0.774658 0 9.8586 0 20.9964C0 32.134 8.9843 41.218 20 41.218Z",
    fill: "#0071CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3213 26.4163C11.6535 22.1619 8.15015 18.3117 12.5586 10.5563C14.3742 7.36219 17.1476 5.25564 20.0126 5.96886C22.8776 5.25572 25.6509 7.36227 27.4665 10.5563C31.8748 18.3117 28.3717 22.1619 26.7036 26.4163L20.0128 26.433L13.3216 26.4163H13.3213Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1974 37.0041C28.8176 39.6444 24.5847 41.218 20 41.218C15.4152 41.218 11.1822 39.6444 7.80249 37.004C7.93165 36.4421 8.05445 35.8808 8.16737 35.3647C8.42392 34.1921 8.62952 33.2524 8.74304 33.0671C10.1703 30.7371 11.942 29.9085 13.4995 29.1801C15.4457 28.2698 17.0575 27.5161 17.2446 24.1847C17.2446 24.1847 18.7272 25.333 19.9438 25.322C21.1604 25.3111 22.7537 24.1089 22.7537 24.1089C22.9416 27.4492 24.5585 28.2216 26.5095 29.1535C28.0645 29.8964 29.8318 30.7406 31.2568 33.0671C31.3702 33.2521 31.5756 34.1909 31.832 35.3627C31.9451 35.8794 32.068 36.4415 32.1974 37.0041Z",
    fill: "#FFD7A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8398 24.9565C22.7999 24.6934 22.7706 24.4121 22.7536 24.1089C22.7536 24.1089 21.1603 25.3111 19.9437 25.322C18.7271 25.333 17.2445 24.1847 17.2445 24.1847C17.2273 24.4934 17.1972 24.779 17.156 25.0456C17.1872 25.0704 17.2181 25.0957 17.2498 25.1204L17.2494 25.1247C17.3431 25.2072 18.7673 26.4454 19.9435 26.4329C21.1198 26.4453 22.5438 25.2069 22.6376 25.1247L22.6373 25.1204C22.7064 25.0669 22.7734 25.0118 22.8396 24.9567L22.8398 24.9565Z",
    fill: "#F0C290"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2497 24.1885C17.3434 24.26 18.7675 25.3326 19.9438 25.3219C21.12 25.3326 22.544 24.2598 22.6378 24.1885C24.4157 23.1405 25.8745 20.0507 25.5452 16.702C25.2755 13.9589 22.3407 17.981 20.2966 12.3213C17.4036 18.4488 14.6558 14.8242 14.3425 17.1464C13.9972 19.705 15.4179 22.9244 17.2497 24.1887V24.1885Z",
    fill: "#FFE1B2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2602 36.9546C28.8702 39.6246 24.6132 41.2178 19.9999 41.2178C15.3839 41.2178 11.1246 39.6227 7.73364 36.9499C7.91599 35.9858 8.08725 34.9484 8.23803 34.035C8.46136 32.6822 8.63976 31.6015 8.74273 31.4342C9.54049 30.1374 11.1885 29.6772 12.7229 29.2488C13.5323 29.0228 14.3101 28.8057 14.9148 28.4792L14.9153 28.4798C18.1619 39.0103 22.2234 38.3288 24.9484 28.3328C25.5382 28.653 26.3536 28.8752 27.2068 29.1077C28.8895 29.5663 30.7193 30.0649 31.2563 31.4342C31.3182 31.5922 31.4587 32.4178 31.6441 33.5071C31.819 34.5346 32.0337 35.7967 32.2602 36.9546ZM14.915 28.4791C14.9149 28.4791 14.9149 28.4791 14.9148 28.4792L14.9147 28.4791H14.915ZM14.915 28.4791C14.9151 28.479 14.9151 28.479 14.9152 28.479V28.4791H14.915Z",
    fill: "#F9A5E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0829 27.4856C15.9691 30.5956 16.4921 35.0015 19.9434 36.1274C16.6941 36.2648 14.5857 31.5312 12.1838 30.2915L16.0828 27.4858V27.4856H16.0829Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9973 27.4856C24.1166 30.5956 23.5676 35.0015 19.9434 36.1274C23.3553 36.2648 25.5695 31.5312 28.0912 30.2915L23.9971 27.4858L23.9973 27.4856Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_993_3125"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40.4436,
    fill: "white",
    transform: "translate(0 0.774414)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAvatarExample);
export default __webpack_public_path__ + "static/media/icAvatarExample.d0c4be842563640a29be18bc77260d51.svg";
export { ForwardRef as ReactComponent };